<div class="row" class="btn-parent">
    <div id="btn-container" class="btn-container" [ngClass]="{'mm-position' : showMoneyMarketHoldings, 'regular-position' : showRegularHoldings}" [hidden]='!showRegularHoldings && !showMoneyMarketHoldings && !showPcfHoldings'></div>
    <div [ngClass]="{ 'scrollable-table': (isScrollableForWindowSize && currentType!=='derivative') , 'scrollable-table-secondary':  (isScrollableForWindowSize && currentType==='derivative')}"
         class="overflow-auto" #holdingsTable>
        <scroll-button id="mainBtn" [hidden]="true" (scrollableEmitter)='setScrollable($event)'
            [selectionChanged]='selectionChanged' [leftHtmlId]='leftHtmlId' [scrollWidth]='scrollWidth' [offsetWidth]='offsetWidth' [passedTable]='holdingsTable'></scroll-button>
        <table class="table" [ngClass]="{'hide-class' : !showRegularHoldings}">
            <thead class="no-wrap">
                <tr id="tr-placeholder">
                    <th id="th-placeholder" class="bolded align-left"
                        [hidden]="!(currentType==='equity'||currentType==='bond'||currentType==='short-term reserve')"
                        style="width:15%">
                        Ticker
                    </th>
                    <th class="bolded align-left" style="width:20%" id="th-placeholder-derivative">
                        Holdings
                    </th>
                    <th *ngIf="profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve')"
                        style="width:17.5%" class="align-right">
                        CUSIP
                    </th>
                    <th *ngIf="profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve')"
                        style="width:17.5%" class="align-right">
                        SEDOL
                    </th>
                    <th *ngIf="currentType==='bond'" style="width:17.5%" class="align-right">Coupon Rate
                    </th>
                    <th *ngIf="currentType==='bond' || (currentType==='short-term reserve' && !profileData?.isETF)"
                        style="width:17.5%" class="align-right">
                        Maturity Date
                    </th>
                    <th *ngIf="currentType==='bond' && profileData?.isStandaloneEtf" style="width:17.5%" class="align-right">
                        Effective Date
                    </th>
                    <th *ngIf="currentType==='bond' || (currentType==='short-term reserve' && !profileData?.isETF)"
                        style="width:17.5%" class="align-right">Face
                        Amount
                    </th>
                    <th style="width:17.5%" class="align-right"
                        *ngIf="(profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve'))|| (currentType==='derivative'||currentType==='currency'||currentType==='commodity')">
                        % of fund<sup *ngIf='profileData?.isStandaloneEtf'>*</sup>
                    </th>
                    <th *ngIf="currentType==='equity'" style="width:17.5%" class="align-right">Shares
                    </th>
                    <th *ngIf="currentType==='derivative'" style="width:17.5%" class="align-right">Quantity
                    </th>
                    <th
                        *ngIf="(currentType==='short-term reserve' && profileData?.isETF) || (currentType==='bond'||currentType==='equity'||currentType==='derivative'||currentType==='currency'||currentType==='commodity')" class="align-right">
                        Market value<sup *ngIf='profileData?.isStandaloneEtf' style="width:17.5%">*</sup>
                    </th>
                    <th *ngIf="currentType==='derivative'" style="width:17.5%" class="align-right">Notional value
                    </th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let holding of holdingsData?.fund?.entity">
                    <th *ngIf="(currentType==='equity'||currentType==='bond'||currentType==='short-term reserve')"
                        style="width:15%"class="align-left" data-rpa-tag-id="symbol"> 
                        {{holding?.ticker ? holding?.ticker : '—'}}
                    </th>
                    <th class="align-left" *ngIf="(isScrollableForWindowSize && currentType==='derivative')" style="width:20%" data-rpa-tag-id="holdings">
                        {{holding?.longName ? holding?.longName : '—'}}
                    </th>
                    <td class="align-left" *ngIf="(isScrollableForWindowSize && currentType!=='derivative' || !isScrollableForWindowSize)"
                        style="width:20%" data-rpa-tag-id="holdings">{{holding?.longName ? holding?.longName : '—'}}
                    </td>
                    <td *ngIf="profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve')"
                        style="width:17.5%" class="align-right" data-rpa-tag-id="cusip">
                        {{holding?.cusip ? holding?.cusip : '—'}}
                    </td>
                    <td *ngIf="profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve')"
                        style="width:17.5%" class="align-right" data-rpa-tag-id="sedol">
                        {{holding.sedol ? holding.sedol : '—'}}
                    </td>
                    <td *ngIf="currentType==='bond'" style="width:17.5%" class="no-wrap align-right" data-rpa-tag-id="couponRate">{{holding.couponRate ?
                        holding.couponRate + '
                        %' : '—'}}
                    </td>
                    <td *ngIf="currentType==='bond' || (currentType==='short-term reserve' && !profileData?.isETF)"
                        style="width:17.5%" class="align-right" data-rpa-tag-id="maturityDate">
                        {{holding.maturityDate ? holding.maturityDate : '—'}}
                    </td>
                    <td *ngIf="currentType==='bond' && profileData?.isStandaloneEtf" style="width:17.5%" class="align-right" data-rpa-tag-id="effectiveDate">
                        {{holding.issueDate ? (holding.issueDate | ESTPipe) : '—'}}
                    </td>
                    <td *ngIf="currentType==='bond' || (currentType==='short-term reserve' && !profileData?.isETF)"
                        style="width:17.5%" class="align-right" data-rpa-tag-id="faceAmount">
                        {{holding.faceAmount && isNumber(holding.faceAmount)?
                        (holding.faceAmount | currency : 'USD' : 'symbol' : '1.0-0') : '—' }}
                    </td>
                    <td style="width:17.5%" class="no-wrap align-right"
                        *ngIf="(profileData?.isETF && (currentType==='equity'||currentType==='bond' || currentType==='short-term reserve'))|| (currentType==='derivative'||currentType==='currency'||currentType==='commodity')" data-rpa-tag-id="fundPercent">
                        {{holding.percentWeight? holding.percentWeight + ' %' : '—' }}
                    </td>
                    <td *ngIf="currentType==='equity' || currentType==='derivative'" style="width:17.5%" class="align-right" data-rpa-tag-id="shares">
                        {{holding.sharesHeld | number}}
                    </td>
                    <td style="width:17.5%" class="align-right"
                        *ngIf="(currentType==='short-term reserve' && profileData?.isETF) || (currentType==='bond'||currentType==='equity'||currentType==='derivative'||currentType==='currency'||currentType==='commodity')" data-rpa-tag-id="marketValue">
                        {{holding.marketValue | currency : 'USD' : 'symbol' : '1.0-0'}}
                    </td>
                    <td style="width:17.5%" *ngIf="currentType==='derivative'" class="align-right" data-rpa-tag-id="notionalValue">{{holding.notionalValue | currency :
                        'USD' : 'symbol' :
                        '1.0-0'}}
                    </td>
                <tr>
            </tbody>
        </table>
        <money-market-results [ngClass]="{'hide-class' : !showMoneyMarketHoldings}" [moneyMarketResults]="holdingsData">
        </money-market-results>
        <pcf-results [pcfHoldings]="holdingsData" [ngClass]="{'hide-class' : !showPcfHoldings}">
        </pcf-results>
        <h5 class="no-funds rps-heading-five"
            *ngIf="(holdingsData && holdingsData?.fund?.entity && (holdingsData?.fund?.entity[0] | json) == '{}') && profileData?.fundId!=0517">
            The fund includes no holdings of this type.</h5>
    </div>
</div>

<!-- add loading spinner! -->